<section class="lg-container installation-container">
  <h2 class="installation-header">{{'LEAD_GENERATION.INSTALLATION.CALLBACK_WIDGET_FOR_YOUR_WEBSITE' | translate}}</h2>
  <div box content class="lg-container">

    <div class="code-container">
      <p class="installation-text" translate>LEAD_GENERATION.INSTALLATION.COPY_CODE_INSTRUCTIONS</p>

      <cc-simple-code-box
        class="html-box"
        mode="html"
        [content]="generatedCode"
      ></cc-simple-code-box>

    </div>

  </div>
  <h2 class="installation-check">{{'LEAD_GENERATION.INSTALLATION.CHECK_INSTALL' | translate}}</h2>
  <form class="install-button-container" (submit)="handleCheckInstallationClick()">

    <input
      [(ngModel)]="checkInstallationUrl"
      class="check-installation-url"
      name="url"
      placeholder="https://">

    <button
      [disabled]="checkingInstallation"
      mat-raised-button
      type="submit"
      color="primary-full"
    >
      {{ 'LEAD_GENERATION.SETTINGS.CHECK_INSTALLATION' | translate }}
    </button>
  </form>
</section>
